import type { StepConfig } from "@portal/components/multiform/types";
import type { AdminCombinedFormData } from "../../schema";
import { AccountTermsStep } from "./AccountTermsStep";
import { AccountTermsSummary } from "./AccountTermsSummary";

export const accountTermsStepConfig: StepConfig<AdminCombinedFormData> = {
	name: "accountTerms",
	label: "Account Terms",
	fieldPaths: ["accountTerms", "indemnityAgreement"],
	component: AccountTermsStep,
	summaryComponent: AccountTermsSummary,
};
